/* src/app/shared/components/modals/projects/project-versions-modal/project-versions-modal.component.scss */
.title {
  text-align: left;
  font: normal normal normal 32px/39px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #007ACE;
  opacity: 1;
}
.subtitle {
  text-align: left;
  font: normal normal normal 16px/19px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
  opacity: 1;
}
.mat-mdc-card {
  padding: 5px;
  border: 1;
}
.mat-mdc-card-image {
  padding: 0;
  object-fit: contain;
  line-break: anywhere;
  width: 50px;
  height: 50px;
}
.card .project-pic {
  object-fit: contain;
  line-break: anywhere;
  width: 50px;
  height: 50px;
}
.flex-container .project-pic {
  width: 243px;
  height: 107px;
}
.center {
  padding: 50px 0;
}
.header,
.footer {
  background-color: #007AC2;
  height: 32px;
}
.header .margin,
.footer .margin {
  margin: 0.5%;
}
.header .close-btn,
.footer .close-btn {
  color: #ffffff;
}
.content {
  padding: 2% 2% 0% 2%;
  height: 95%;
}
.content .input-name {
  font-size: 20px;
  font-weight: 500;
  color: #007AC2;
}
mat-card:hover .selection {
  opacity: 1;
}
mat-card.mat-elevation-z4 .selection {
  opacity: 1;
}
.card-selected {
  border: 2px solid #007ACE;
}
.selection {
  opacity: 0;
  cursor: pointer;
  color: #007ACE;
  background: #fff;
  position: absolute;
  right: -10px;
  top: -10px;
  border-radius: 100%;
  height: 24px;
  width: 24px;
}
#inner-grid {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1607843137);
  border-radius: 4px;
  opacity: 1;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 5px;
  margin-left: 5px;
  display: grid;
  grid-template-columns: 0.2fr 1fr;
  grid-gap: 5px;
}
#inner-grid > div {
  vertical-align: middle;
}
.remover {
  padding: 5px;
  float: left;
  width: 50%;
  text-align: left;
  font: normal normal normal 14px/18px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #C21E00 !important;
  opacity: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.remover:hover {
  padding: 5px;
  float: left;
  width: 50%;
  text-align: left;
  font: normal normal normal 16px/20px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #C21E00 !important;
  opacity: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.divButtons {
  padding: 5px;
  float: right;
}
.mat-icon {
  margin-right: 0px;
}
.box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  font: normal normal medium 20px/24px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
  opacity: 1;
}
/*# sourceMappingURL=project-versions-modal.component.css.map */
